import React, { Component } from 'react'
import Button from '../../UI/Button/Button'
import { InputTextVal } from '../../UI/Input/Input'
import Select from '../../UI/Select/Select'
import { ONBOARDING_API, WAPPA_PROXY } from '../../../constants/ApiConstants'
import { UF_LIST } from '../../../constants/UfList'
import axios from 'axios'

export default class ClientAddress extends Component {
    constructor() {
        super()

        this.state = {
            zipCode: '',
            state: '',
            city: '',
            district: '',
            address: '',
            number: '',
            complement: ''
        }
    }

    handleChange = event => {
        const isCheckbox = event.target.type === 'checkbox'

        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        })
    }

    handleSelectChange = (name, val) => {
        this.setState({
            [name]: val
        })
    }

    fillAddress() {
        axios.get(`${WAPPA_PROXY}ZipCode?zipcode=${this.state.zipCode}`).then(resp => {
            document.getElementsByName("number")[0].focus()

            this.setState({
                state: resp.data.uf,
                city: resp.data.localidade,
                district: resp.data.bairro,
                address: resp.data.logradouro
            }, () => {
                console.log(this.state)
            })
        }).catch(error => {
            
        })
    }

    sendClienteAddress = event => {
        event.preventDefault()

        const companyId = sessionStorage.getItem('companyId')

        const req = {
            zipCode: this.state.zipCode,
            state: this.state.state,
            city: this.state.city,
            district: this.state.district,
            address: this.state.address,
            number: this.state.number,
            complement: this.state.complement
        }

        axios.post(`${ONBOARDING_API}${companyId}/location`, req).then(resp => {
            this.props.sendInfo(this, 5)
        }).catch(error => {
            alert(error.response.message)
        })
    }

    render() {
        return(
            <form action="clientInfo" autoComplete="none">
                <div className="row">
                    <InputTextVal
                        text="CEP"
                        autoComplete="off"
                        mask="zipCode"
                        name="zipCode"
                        max="99999999"
                        maxLength={8}
                        onChange={this.handleChange}
                        value={this.state.zipCode}
                        error={this.state.zipCodeError}
                        onBlur={this.fillAddress.bind(this)}
                        // setError={this.setError.bind(this, 'zipCodeError')}
                    ></InputTextVal>
                </div>
                <div className="row">
                    <InputTextVal
                        type="text"
                        autoComplete={'off'}
                        onChange={this.handleChange}
                        value={this.state.address || ''}
                        focus={this.state.address && 'focus'}
                        name="address"
                        text="Endereço"
                    ></InputTextVal>
                </div>
                <div className="row">
                    <InputTextVal
                        type="text"
                        name="number"
                        autoComplete={'off'}
                        onChange={this.handleChange}
                        text="Numero"
                    ></InputTextVal>
                </div>
                <div className="row">
                    <InputTextVal
                        type="text"
                        name="city"
                        autoComplete={'off'}
                        onChange={this.handleChange}
                        value={this.state.city || ''}
                        focus={this.state.city && 'focus'}
                        text="Cidade"
                    ></InputTextVal>
                </div>
                <div className="row">
                    <InputTextVal
                        type="text"
                        name="district"
                        autoComplete={'off'}
                        onChange={this.handleChange}
                        value={this.state.district || ''}
                        focus={this.state.district && 'focus'}
                        text="Bairro"
                    ></InputTextVal>
                </div>
                <div className="row">
                    <Select
                        label="Estado"
                        name="state"
                        responseType={'string'}
                        onChange={this.handleSelectChange.bind(this, 'state')}
                        value={this.state.state}
                        options={UF_LIST}>
                    </Select>
                </div>
                <div className="row">
                    <InputTextVal
                        type="text"
                        name="complement"
                        autoComplete={'off'}
                        onChange={this.handleChange}
                        value={this.state.complement || ''}
                        focus={this.state.complement && 'focus'}
                        text="Complemento"
                    ></InputTextVal>
                </div>
                <div className="options">
                    <Button
                        onClick={this.sendClienteAddress.bind(this)}
                        disabled={
                            !this.state.zipCode ||
                            !this.state.state ||
                            !this.state.city ||
                            !this.state.district ||
                            !this.state.address ||
                            !this.state.number
                        }
                        text="Avançar"
                    ></Button>
                </div>
            </form>
        )
    }
}